import { createContext, useContext } from 'react';

export const FreezeContext = createContext(false);

export const useInFreezeColumn = () => {
  return useContext(FreezeContext);
};
